import { routingConstants, commonConstants } from "../_constants";
import { apiCall } from "../_helpers";
import { appNotification } from "../_components";

const {
  GET_ALL_ROUTES_START,
  GET_ALL_ROUTES_SUCCESS,
  GET_ALL_ROUTES_FAILED,
  ADD_ROUTE_START,
  ADD_ROUTE_END,
  ADD_ROUTE_FAILED,
  VIEW_ROUTE_START,
  VIEW_ROUTE_SUCCESS,
  VIEW_ROUTE_FAILED,
  EDIT_ROUTE_START,
  EDIT_ROUTE_END,
  EDIT_ROUTE_SUCCESS,
  EDIT_ROUTE_FAILED,
  FILTER_ROUTE_START,
  FILTER_ROUTE_SUCCESS,
  FILTER_ROUTE_FAILED,
} = routingConstants;

const { SUCCESSFUL_CODE, GLOBAL_LOADING_START, GLOBAL_LOADING_ENDED } =
  commonConstants;

const TEMP_BASE_URL = "https://automated-terminal-registration.k8.isw.la";

const getAllRoutes = () => {
  return (dispatch) => {
    dispatch({ type: GET_ALL_ROUTES_START });
    dispatch({ type: GLOBAL_LOADING_START });
    const url = `${TEMP_BASE_URL}/api/v1/routing/all`;
    apiCall
      .get(url)
      .then((response) => {
        const { message, content, status } = response.data;

        if (status !== SUCCESSFUL_CODE) {
          const error = {
            errorMessage: message,
          };
          dispatch({ type: GET_ALL_ROUTES_FAILED, payload: error });

          return;
        }
        dispatch({
          type: GET_ALL_ROUTES_SUCCESS,
          payload: content,
        });
      })
      .catch((error) => {
        const payload = {
          errorMessage: `This was caused by ${error.message} Please try again`,
        };
        dispatch({ type: GET_ALL_ROUTES_FAILED, payload });
      });
  };
};

const viewRoute = (id, onSuccessCallback) => {
  return (dispatch) => {
    dispatch({ type: VIEW_ROUTE_START });
    dispatch({ type: GLOBAL_LOADING_START });
    const url = `${TEMP_BASE_URL}/api/v1/routing/find?code=${id}`;
    apiCall
      .get(url)
      .then((response) => {
        const content = response.data;
        onSuccessCallback();
        dispatch({ type: VIEW_ROUTE_SUCCESS, payload: content });
      })
      .catch((error) => {
        const payload = {
          errorMessage: `This was caused by ${error.message} Please try again`,
        };
        appNotification(
          payload.errorMessage,
          "Unable to get Route's Details",
          "error"
        );
        dispatch({ type: VIEW_ROUTE_FAILED, payload });
      });
  };
};

const createRoute = (data, onSuccessCallback) => {
  return (dispatch) => {
    dispatch({ type: ADD_ROUTE_START });
    dispatch({ type: GLOBAL_LOADING_START });
    const url = `${TEMP_BASE_URL}/api/v1/routing/create`;
    apiCall
      .post(url, data)
      .then((response) => {
        const { message, status } = response;
        if (status !== 200) {
          const data = response.response.data;
          const error = {
            errorMessage: data[0].message,
          };
          dispatch({ type: ADD_ROUTE_FAILED, payload: error });
          throw new Error(error.errorMessage);
        }

        if (status === 200) {
          const data = response.data;
          const { message, status } = data;
          if (status !== "00") {
            const error = {
              errorMessage: message,
            };
            dispatch({ type: ADD_ROUTE_FAILED, payload: error });
            throw new Error(error.errorMessage);
          } else {
            onSuccessCallback();
            dispatch({ type: EDIT_ROUTE_SUCCESS });
            dispatch({ type: GLOBAL_LOADING_ENDED });
            appNotification(
              "Route has been created successfully",
              "Route Added",
              "success"
            );
          }
        }
      })
      .catch((error) => {
        const payload = {
          errorMessage: `${error.message}. Please try again`,
        };
        dispatch({ type: ADD_ROUTE_FAILED, payload });
        dispatch({ type: GLOBAL_LOADING_ENDED });
        appNotification(payload.errorMessage, "Unable to add Route", "error");
      });
  };
};

const editRoute = (id, data, onSuccessCallback) => {
  return (dispatch) => {
    dispatch({ type: EDIT_ROUTE_START });
    dispatch({ type: GLOBAL_LOADING_START });
    const url = `${TEMP_BASE_URL}/api/v1/routing/update/${id}`;
    apiCall
      .put(url, data)
      .then((response) => {
        const { status, message } = response;

        if (status !== 200) {
          const data = response.response.data;
          const error = {
            errorMessage: data[0].message,
          };
          dispatch({ type: EDIT_ROUTE_FAILED, payload: error });
          throw new Error(error.errorMessage);
        }

        if (status === 200) {
          const data = response.data;
          const { message, status } = data;
          if (status !== "00") {
            const error = {
              errorMessage: message,
            };
            dispatch({ type: EDIT_ROUTE_FAILED, payload: error });
            throw new Error(error.errorMessage);
          } else {
            onSuccessCallback();
            dispatch({ type: EDIT_ROUTE_SUCCESS });
            dispatch({ type: GLOBAL_LOADING_ENDED });
            appNotification(
              "Route has been updated successfully",
              "Route Updated",
              "success"
            );
          }
        }
      })
      .catch((error) => {
        const payload = {
          errorMessage: `${error.message}. Please try again`,
        };
        dispatch({ type: EDIT_ROUTE_FAILED, payload });
        dispatch({ type: GLOBAL_LOADING_ENDED });
        appNotification(
          payload.errorMessage,
          "Unable to update Route",
          "error"
        );
      });
  };
};

const routingActions = {
  getAllRoutes,
  viewRoute,
  createRoute,
  editRoute,
};

export default routingActions;
